import AXIOS from '@/utils/$axios';

//获取短信验证码
export const getSMSVerificationCode = data =>
    AXIOS.post('/hdc-admin/sys/sms/send', data);

// 获取用户信息
export const getUserInfo = () => AXIOS.get('/hdc-admin/sys/user/info');

// 校验验证码
export const checkSms = data =>
    AXIOS.post('/hdc-admin/sys/user/checkSms', data);
// 重置密码
export const modifyPassword = data =>
    AXIOS.post('/hdc-admin/sys/user/modifyPassword', data);

// 注销
export const putCancellation = data =>
    AXIOS.post('/hdc-admin/sys/user/delete', data);

// 获取权益数据
export const queryAuths = (data, from) =>
    AXIOS.post('/hdc-admin/sys/vip/list-auths', data, {from});

export const authsUse = (data) => {
    return AXIOS.post('/hdc-admin/sys/vip/use', data);
}
// 领取公众号礼品
export const postMobile = data =>
    AXIOS.post('/hdc-admin/hdc/product/benefits-mp', data);

// 线索列表
export const getClueList = data =>
    AXIOS.post('/space/collection/get-clue', data);

// 线索详情
export const getClueDetail = data =>
    AXIOS.post('/space/collection/get-clue-detail', data);

// 线索修改
export const putClue = data => AXIOS.post('/space/collection/edit-clue', data);
// 线索已读
export const postClueRead = data =>
    AXIOS.post('/space/collection/read-clue', data);
// 删除线索
export const deleteClueRead = data =>
    AXIOS.post('/space/collection/delete-clue', data);
// 检测渠道码
export const checkCode = params =>
    AXIOS.post('hdc-admin/sys/user/check-cb', null, {
        params,
        cancelWarn() {
            return true;
        },
    });
// 绑定渠道
export const bindCode = params =>
    AXIOS.post('hdc-admin/sys/user/bind-cb', null, {
        params,
        cancelWarn() {
            return true;
        },
    });
